export const getDefaultState = () => {
  return {
    demo: null,
    menuDetail: null
  }
}

const state = getDefaultState()
export default state
